import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { ActionSheetContent } from '@/components/action-sheet';
import { CollectionOptionType } from '@/hooks/use-collection-list-options';
import { SCREEN_PADDING } from '@/styles';
import { StyleSheet, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  collection: CollectionOptionType;
  goBack: () => void;
  onDeletePress: () => void;
  onDuplicatePress: () => void;
  onRenamePress: () => void;
}

export const EditCollectionActionsContent: React.FC<Props> = ({
  collection,
  goBack,
  onDeletePress,
  onDuplicatePress,
  onRenamePress,
}) => {
  const { isSmallLayout } = useLayoutContext();
  const [actions, primaryIndices, dangerIndices] = useMemo(() => {
    const isRestrictedCollection =
      collection.metadata!.isDefault ||
      collection.metadata!.isLinked ||
      collection.metadata!.type === 'supplier';
    const baseActions = isRestrictedCollection
      ? [i18n.t('duplicate')]
      : [i18n.t('rename'), i18n.t('duplicate'), i18n.t('delete')];

    const primary = [];

    if (isSmallLayout) {
      baseActions.push(i18n.t('back'));
      primary.push(baseActions.length - 1);
    }

    const danger = isRestrictedCollection ? [] : [2];

    return [baseActions, primary, danger];
  }, [isSmallLayout, collection]);

  return (
    <View style={styles.base}>
      <ActionSheetContent
        actions={actions}
        dangerIndices={dangerIndices}
        onAction={(name) => {
          if (name === i18n.t('delete')) {
            onDeletePress();
            return;
          } else if (name === i18n.t('duplicate')) {
            onDuplicatePress();
            return;
          } else if (name === i18n.t('rename')) {
            onRenamePress();
            return;
          }
          // TODO: implement rename and duplicate
          goBack();
        }}
        primaryIndices={primaryIndices}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    marginHorizontal: SCREEN_PADDING,
  },
});
